export default "__VITE_ASSET__ByUXxrkD__"